export const CREATING_ITINERARY = "CREATING_ITINERARY";
export const UPDATING_ITINERARY = "UPDATING_ITINERARY";
export const ITINERARY_CREATED = "ITINERARY_CREATED";
export const ITINERARY_UPDATED = "ITINERARY_UPDATED";
export const ERROR_ITINERARY_CREATE = "ERROR_ITINERARY_CREATE";
export const ERROR_ITINERARY_UPDATE = "ERROR_ITINERARY_UPDATE";
export const UPDATED_RECENTLY = "UPDATED_RECENTLY";
export const SET_UPDATED_RECENTLY_TO_FALSE = "SET_UPDATED_RECENTLY_TO_FALSE";
